import styled from 'styled-components';
import C from '@assets/themes/colors';


export const Root = styled.div`
  flex: 1;
  display: flex;
  overflow-y: auto;
  font-family: Roboto;
  padding: 23px 39px;
  display: block;
  position: relative;
`;

export const OEMCheck = styled.div`
  position: absolute;
  right: 58px;
  top: 97px;
  > div {
    padding: unset;
  }
`;

export const Back = styled.div`
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${C.BLUE};
  position: relative;
  padding-left: 23px;
  cursor: pointer;
  width: fit-content;
`;

export const Icon = styled.div`
  position: absolute;
  left: 0px;
  top: -4px;
`;

export const BrandNameLabel = styled.div`
  font-size: 30px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${C.DARK_BLUE};
  margin-top: 40px;
  margin-bottom: 33px;
`;

export const Edit = styled.span`
  cursor: pointer;
`;

export const BrandName = styled.input`
  font-family: Roboto; 
  font-size: 30px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${C.DARK_BLUE};
  margin-top: 40px;
  margin-bottom: 33px;
  border: none;
  background-color: var(--white);
  text-align: left;
  outline: none;
  width: 100%;
  padding: unset;
`;

export const IndustryLabel = styled.div`
  font-size: 16px;
  font-weight: normal;
  color: ${C.DARK_GRAY};  
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;  
  position: absolute;
  right: 335px;
  top:40px;
`;
